/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConnectorTaskStatus,
    ConnectorTaskStatusFromJSON,
    ConnectorTaskStatusFromJSONTyped,
    ConnectorTaskStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface TaskStatus
 */
export interface TaskStatus {
    /**
     * 
     * @type {number}
     * @memberof TaskStatus
     */
    id: number;
    /**
     * 
     * @type {ConnectorTaskStatus}
     * @memberof TaskStatus
     */
    state: ConnectorTaskStatus;
    /**
     * 
     * @type {string}
     * @memberof TaskStatus
     */
    workerId: string;
    /**
     * 
     * @type {string}
     * @memberof TaskStatus
     */
    trace?: string;
}

export function TaskStatusFromJSON(json: any): TaskStatus {
    return TaskStatusFromJSONTyped(json, false);
}

export function TaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'state': ConnectorTaskStatusFromJSON(json['state']),
        'workerId': json['worker_id'],
        'trace': !exists(json, 'trace') ? undefined : json['trace'],
    };
}

export function TaskStatusToJSON(value?: TaskStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state': ConnectorTaskStatusToJSON(value.state),
        'worker_id': value.workerId,
        'trace': value.trace,
    };
}

